module.exports = __webpack_public_path__ + "static/img/5.bf638a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/5.png
// module id = ybGf
// module chunks = 0